/* Shuffle product grids marked [data-om-shuffle] and show only data-show of them.
   Gives a fresh random selection on each page load. Runs once per page. */
(function () {
  if (window.__omShuffleDone) return;
  window.__omShuffleDone = true;
  function run() {
    document.querySelectorAll('[data-om-shuffle]').forEach(function (g) {
      var show = parseInt(g.getAttribute('data-show') || '6', 10);
      var cards = Array.prototype.slice.call(g.children);
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
      }
      cards.forEach(function (c, idx) {
        c.style.display = idx < show ? '' : 'none';
        g.appendChild(c);
      });
    });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
